/* The Aquatic Garage — premium layer: header state + reveal motion */
(function () {
  var root = document.documentElement;
  var headerSection = document.querySelector('.section-header');

  function setHeaderHeight() {
    if (!headerSection) return;
    var h = headerSection.getBoundingClientRect().height;
    root.style.setProperty('--tag-header-h', Math.round(h) + 'px');
  }

  setHeaderHeight();
  window.addEventListener('load', setHeaderHeight);
  if ('ResizeObserver' in window && headerSection) {
    new ResizeObserver(setHeaderHeight).observe(headerSection);
  } else {
    window.addEventListener('resize', setHeaderHeight);
  }

  /* Solid header once the visitor scrolls past the top of the page */
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      root.classList.toggle('tag-scrolled', window.scrollY > 24);
      ticking = false;
    });
  }
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  /* Gentle reveal for editorial sections */
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function initReveal(scope) {
    var items = (scope || document).querySelectorAll('[data-tag-reveal]:not(.is-in)');
    if (!items.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }
  initReveal();
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); setHeaderHeight(); });
  /* Driftwood gallery: pieces priced at $0 show no price rather than "$0.00" */
  function hideZeroPrices(scope) {
    (scope || document).querySelectorAll("[class^='driftwood-'] [data-price-raw='0']").forEach(function (card) {
      card.setAttribute('data-price', '');
      var p = card.querySelector("[class$='__card-price']");
      if (p) p.remove();
    });
  }
  hideZeroPrices();
  document.addEventListener('shopify:section:load', function (e) { hideZeroPrices(e.target); });
})();
